<template>
  <div class="receipt-detail-drawer">
    <finance-drawer
      title="分账单详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="divideNo"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleOpen"
    >
      <div v-loading="loading">
        <div class="main-cont">
          <div class="main-cont-item">
            <h2 class="title-text">
              基本信息
              <icon-status
                :color="setStatusColor(detailInfo.divideStatus, 'divideStatus')"
                :status="detailInfo.divideStatusDesc"
              />
            </h2>
            <el-row :gutter="20" style="margin-top: -8px;">
              <jr-col :data-show="firstCol" :data="detailInfo">
                <template #payReason>
                  <jr-tooltip :content="detailInfo.payReason || '-'" />
                </template>
                <template #orderNumber>
                  <jr-tooltip :content="detailInfo.orderNumber" type="popover" />
                </template>
              </jr-col>
              <jr-col :data-show="secondCol" :data="detailInfo" />
              <jr-col :data-show="thirdCol" :data="detailInfo" />
            </el-row>
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">分账明细</h2>
            <el-table
              border
              size="mini"
              style="width: 100%"
              row-class-name="table-row"
              header-row-class-name="table-header-cell"
              :data="(divideDetailList || [])"
              :span-method="objectSpanMethod"
            >
              <el-table-column
                label="分账请求编号"
                prop="divideFlowNo"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.divideFlowNo || '-'}}
                </template>
              </el-table-column>
              <el-table-column
                label="收款编号"
                prop="receiptNo"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.receiptNo || '-'}}
                </template>
              </el-table-column>

              <el-table-column
                label="客户编号"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.businessNo || '-'}}
                </template>
              </el-table-column>

              <el-table-column
                label="客户名称"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.businessName || '-'}}
                </template>
              </el-table-column>

              <el-table-column
                label="账户编号"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.accountNo || '-'}}
                </template>
              </el-table-column>

              <el-table-column
                label="账户名称"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.accountName || '-'}}
                </template>
              </el-table-column>

              <el-table-column
                label="分账金额"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.divideAmount | toFenThousandsAndFloat}}
                </template>
              </el-table-column>

              <el-table-column
                label="状态"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.statusDesc || '-'}}
                </template>
              </el-table-column>

              <el-table-column
                label="分账凭证"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row, index}">
                  <span v-if="!row.certificate">-</span>
                  <jr-preview-image
                    v-else
                    :row-id="index"
                    :image-list="$stringToArray(row.certificate)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">分账方案</h2>
            <el-table
              border
              size="mini"
              style="width: 100%"
              row-class-name="table-row"
              header-row-class-name="table-header-cell"
              :data="(divideList || [])"
              :span-method="objectSpanMethod"
            >
              <el-table-column
                label="分账申请编号"
                prop="divApplyNo"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.divideApplyNo || '-'}}
                </template>
              </el-table-column>

              <el-table-column
                label="客户编号"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.businessNo || '-'}}
                </template>
              </el-table-column>

              <el-table-column
                label="客户名称"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.businessName || '-'}}
                </template>
              </el-table-column>

              <el-table-column
                label="分账金额"
                align="center"
                min-width="1"
              >
                <template slot-scope="{row}">
                  {{row.divideAmount | toFenThousandsAndFloat}}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </finance-drawer>
  </div>
</template>
<script>
import { mergeTableRowAndRefer, objectSpanMethod } from '@/utils/table-merge';
import { getDivideDetail } from '@/api/receivables/sub-account';
import { setStatusColor } from '@/filters/index';

export default {
  props: {
    divideNo: {
      type: String,
      default: '',
    },
  },
  computed: {
    // 分账明细
    divideDetailList() {
      return mergeTableRowAndRefer((this.detailInfo.divideFlow || []), ['divideFlowNo', 'receiptNo'], 'divideFlowNo');
    },
    // 分账方案
    divideList() {
      return mergeTableRowAndRefer((this.detailInfo.divideDetail || []), ['divideApplyNo'], 'divideApplyNo');
    },
  },
  data() {
    return {
      detailInfo: {},
      loading: false,
      // 基础信息
      firstCol: [
        { label: '分账申请号:', prop: 'divideApplyNo' },
        { label: '业务订单号:', prop: 'orderNumber' },
        { label: '分账单状态:', prop: 'divideStatusDesc' },
      ],
      secondCol: [
        { label: '分账金额:', prop: 'divideAmount', filters: 'toFenThousandsAndFloat', className: 'detail-amount_num' },
        { label: '分款单类型:', prop: 'divideTypeDesc' },
        { label: '创建时间:', prop: 'createTime', filters: 'formatTime' },
      ],
      thirdCol: [
        { label: '归属业务:', prop: 'busiSourceDesc' },
        { label: '分账审核人:', prop: 'approvalUser' },
        { label: '分账完成时间:', prop: 'finishTime', filters: 'formatTime' },
      ],
      objectSpanMethod,
    };
  },
  watch: {
    divideNo: {
      deep: true,
      handler() {
        if (this.divideNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    setStatusColor,
    handlePictureCardPreview(file, index, gallery) {
      const viewer = this.$refs[gallery].$viewer;
      viewer.view(index);
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.detailInfo = {};
        this.getDivideDetail();
      });
    },
    // 获取付款管理详情接口
    async getDivideDetail() {
      try {
        this.detailInfo = {};
        if (!this.divideNo) {
          this.$message({
            message: '分账编号不能为空！！',
            type: 'warning',
          });
          return;
        }
        this.loading = true;
        const res = await getDivideDetail(this.divideNo);
        this.detailInfo = res.data || {};
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.table-button {
  margin-bottom: 0;
}
</style>

